<template>
<div id="secure">

    <TopMenu />
    <section class="main-content columns is-fullheight">
        <div class="container column is-12">
            <div class="section">
                <a class="button is-info is-outlined" v-on:click="goTutorial()" style="margin-top:-10px; margin-bottom: 5px;">
                    <span class="icon navbar-icon"><i class="fa fa-youtube-play"></i></span> Tutorial
                </a>
                <a class="button is-info is-outlined" v-on:click="getHelp()" style="margin-top:-10px; margin-bottom: 5px;">
                    <span class="icon navbar-icon"><i class="fa fa-question-circle"></i></span> Help
                </a>
                <a class="button is-info" href="https://www.studentqr.com/download" target="_blank" style="margin-top:-10px; margin-bottom: 5px;">
                    <span class="icon navbar-icon"><i class="fa fa-cloud-download"></i></span> Download App
                </a>
                <div class="card is-hidden1">
                    <div class="card-header">
                        <p class="card-header-title">Group Leaderboard for {{ monthDisplay }} {{ actionYear }} 
                        <!-- <span class="last-refresh">Last updated on {{ lastRefresh }}</span> -->
                        </p>
                        <div style="margin: 10px; margin-left: 0px;">
                            <a class="button is-info is-small" style="margin-left: 5px;" v-on:click="getTopGroup('excel')">Excel</a>
                        </div>
                        <b-select id="duration" name="duration" v-model="duration" class="header-input" @input="getLeaderboard()">
                            <option selected value="0">Whole Year</option>
                            <option selected value="1">January</option>
                            <option selected value="2">February</option>
                            <option selected value="3">March</option>
                            <option selected value="4">April</option>
                            <option selected value="5">May</option>
                            <option selected value="6">June</option>
                            <option selected value="7">July</option>
                            <option selected value="8">August</option>
                            <option selected value="9">September</option>
                            <option selected value="10">October</option>
                            <option selected value="11">November</option>
                            <option selected value="12">December</option>
                        </b-select>
                    </div>
                    <div class="card-content">

                        <loading :active.sync="isLoading" 
                            :can-cancel="false" 
                            :is-full-page="true">
                        </loading>
                        
                        <div class="content">
                            <div class="columns">    
                                <div class="column is-one-fifth">#</div>
                                <div class="column">Group Name</div>
                                <div class="column is-one-fifth text-center">Points</div>
                            </div>
                            <div class="columns top-border" v-for="(top,index) in sortTop(topGroup)" :key="top._id" v-show="topGroup.length > 0">
                                <div class="column is-one-fifth">{{ index + 1 }}</div>
                                <div class="column">{{ top.level }} {{ top.name }}</div>
                                <div class="column is-one-fifth text-center">{{ top.tempNumber1 }}</div>
                            </div>
                            <span v-show="topGroup.length == 0" class="inline-error-message">{{ topGroupErrorMessage }}</span>
                        </div>
                    </div>
                </div>
                <br />
            </div>
        </div>
    </section>    
</div>
</template>

<script>
import TopMenu from '../TopMenu'
import axios from 'axios'
import "../public/style.scss";
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';


export default {
    name: "GroupLeaderboard",
    components: {
        TopMenu,
        Loading,
    },
    data() {
        return {
            isLoading: false,
            dateDisplay: '',
            actionDate: 0,
            actionMonth: 0,
            actionYear: 0,
            duration: 1,
            monthDisplay: '',
            topGroup: [],
            topGroupErrorMessage: '',
            lastRefresh: '',
            schoolID: ''
        };
    },
    beforeMount() {
        this.$emit("authenticated", true);
    },
    created() {
        this.schoolID = localStorage.getItem('schoolID');
        var currentDate = new Date();
        var currentDay = currentDate.getDate();
        if (currentDate.getDate() < 10){
            currentDay = "0" + currentDay;
        }
        this.actionYear = currentDate.getFullYear()
        var currentMonth = currentDate.getMonth() + 1;  //since month starts from 0
        this.duration = currentMonth
        this.actionMonth = currentMonth;
        if (currentMonth < 10){
            currentMonth = "0" + currentMonth;
        }
        this.actionDate = this.actionYear + "" + currentMonth + "" + currentDay;

        var month = currentDate.getMonth();
        var dayOfWeek = currentDate.getDay();

        var dayOfWeekDisplay = "";
        switch (dayOfWeek){
            case 0:
                dayOfWeekDisplay = "Sunday";
                break;
            case 1:
                dayOfWeekDisplay = "Monday";
                break;
            case 2:
                dayOfWeekDisplay = "Tuesday";
                break;
            case 3:
                dayOfWeekDisplay = "Wednesday";
                break;
            case 4:
                dayOfWeekDisplay = "Thursday";
                break;
            case 5:
                dayOfWeekDisplay = "Friday";
                break;
            case 6:
                dayOfWeekDisplay = "Saturday";
                break;
            default:
                dayOfWeekDisplay = "Monday";
                break;
        }

        var monthDisplay = this.getMonthDisplay(month);

        this.monthDisplay = monthDisplay;
        this.dateDisplay = dayOfWeekDisplay + ", " + currentDate.getDate() + " " + monthDisplay + " " + currentDate.getFullYear();
    },
    mounted(){
        this.getTopGroup('')
    },
    methods: {
        goTutorial(){
            window.open("https://www.studentqr.com/resources", '_blank');
        },
        getHelp(){            
            window.open("https://helpstudentqr.wasap.my", '_blank');
        },
        getLeaderboard(){
            this.getTopGroup('')
        },
        timeDifference(ts1,ts2){
            //https://stackoverflow.com/questions/16767301/calculate-difference-between-2-timestamps-using-javascript?noredirect=1&lq=1
            var difference = ts1 - ts2;

            //var daysDifference = Math.floor(difference/1000/60/60/24);
            var hoursDifference = Math.floor(difference/1000/60/60);
            //var minutesDifference = Math.floor(difference/1000/60);

            return hoursDifference;
        },
        sortTop(arrays){
            return _.orderBy(arrays, 'tempNumber1', 'desc').splice(0,50); //we're using the magical lodash function here to sort by points and return the only top 5 
        },
        getTopGroup(output){
            let self = this;
            this.isLoading= true;

            var show = 'all';

            if (self.duration == 0){
                show = 'all';
            }else{
                show = 'monthly'
                self.actionMonth = self.duration
            }

            if (output == "excel"){
                axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
                axios.defaults.responseType = 'blob'
                axios.defaults.timeout = 0
                axios.post(process.env.MY_URL + '/api/group/leaderboard', {
                        params: {
                            email: localStorage.getItem('email'),
                            sessionID: localStorage.getItem('sessionID'),
                            show: 'group',
                            limit: 20,
                            actionYear: self.actionYear,
                            actionMonth: self.actionMonth,
                            duration: self.duration,
                            output: 'excel'
                        }
                    })
                   .then(response => {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', "Group Leaderboard_" + self.getMonthDisplay(self.duration - 1) + "_" + self.actionYear + ".xlsx"); //or any other extension
                        document.body.appendChild(link);
                        link.click();
                        self.isLoading = false;

                    })
                    .catch(e => {
                        console.log(e)
                        self.isLoading = false
                    })
            }else{
                console.log("209 before post /group/leaderboard")
                axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
                axios.defaults.responseType = 'json'
                axios.defaults.timeout = 0
                axios.post(process.env.MY_URL + '/api/group/leaderboard', {
                        params: {
                            email: localStorage.getItem('email'),
                            show: 'group',
                            limit: 20,
                            actionYear: self.actionYear,
                            actionMonth: self.actionMonth,
                            duration: self.duration,
                            output: ''
                        }
                    })
                    .then(response => {                        
                        if (response.data.success == false){
                            self.topGroup = []
                            self.topGroupErrorMessage = response.data.msg
                        }else{
                            self.topGroup = response.data
                        }
                        self.isLoading = false
                    })
                    .catch(e => {
                        console.log(e)
                        self.isLoading = false
                    })
            }
        },
        getMonthDisplay(month){
            month = parseInt(month)
            var monthDisplay = "";
            switch (month){
                case 0:
                    monthDisplay = "January";
                    break;
                case 1:
                    monthDisplay = "February";
                    break;
                case 2:
                    monthDisplay = "March";
                    break;
                case 3:
                    monthDisplay = "April";
                    break;
                case 4:
                    monthDisplay = "May";
                    break;
                case 5:
                    monthDisplay = "June";
                    break;
                case 6:
                    monthDisplay = "July";
                    break;
                case 7:
                    monthDisplay = "August";
                    break;
                case 8:
                    monthDisplay = "September";
                    break;
                case 9:
                    monthDisplay = "October";
                    break;
                case 10:
                    monthDisplay = "November";
                    break;
                case 11:
                    monthDisplay = "December";
                    break;
                default:
                    monthDisplay = "";
                    break;
            }
            return monthDisplay;
        }
    }
};
</script>

<style scoped>
.kelas-button{
    margin-right: 10px;
    margin-bottom: 10px;
}
.header-tag{
    float: right !important;
    border: 1px solid #209cee;
    color: #209cee;
    padding-bottom: calc(0.375em - 1px);
    padding-left: 0.75em;
    padding-right: 0.75em;
    padding-top: calc(0.375em - 1px);
    align-items: center;
    border-radius: 4px;
    font-size: 1rem;
    height: 2.25em;
    line-height: 1.5;
    margin: 10px;
}
.header-date{
    float: right;
    padding: 10px;
}
.attendance-pie{
    width: 250px;
    height: 250px;
}
.header-input{
    margin: 10px;
}
.header-icon{
    margin: 5px;
}
.last-refresh{
    font-weight: normal;
    font-size: 0.9rem;
    font-style: italic;
    margin-left:20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Group/Leaderboard.vue